export default function createConsoleTransport() {
  return function consoleTransport({
    loggerName,
    level,
    message,
    transactionID,
    data,
  }) {
    const method = String(level).toLowerCase();

    (console[method] || console.log)(
      `[${loggerName}]:`,
      level.toUpperCase(),
      message,
      {
        transactionID,
        ...data,
      }
    );
  };
}
